import { useContext, useState } from "react";
import { Box, ButtonBase, Grid } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { ScreenContext } from "../context/ScreenContext";
import { useNavigate } from "react-router-dom";

const TypesOfService = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(fulter[0]);

  const handleClick = (item) => {
    setSelected(item);
  };
  // 1610
  return (
    <Grid container sx={design.Direction}>
      <Box
        sx={{
          ...design.backgroundIMG,
          height: "14.5vw",
        }}
      />

      <CustomText variant="subtitle1" color="#000" sx={design.Title}>
        Cuida de tu salud y la de tu familia
      </CustomText>
      <Grid container sx={design.AlignButtons}>
        {fulter.map((doc) => {
          const isActive = selected?.name === doc.name;
          return (
            <Grid item key={doc.name} sx={{ m: 1 }}>
              <ButtonBase
                onClick={() => handleClick(doc)}
                sx={{
                  backgroundColor: isActive ? doc.color : "#fff",
                  border: `2px solid ${doc.color}`,
                  color: isActive ? "#fff" : doc.color,
                  ...design.ButtonBase,
                }}
              >
                {doc.name}
              </ButtonBase>
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={3} width="100%" mt={1}>
        <Grid item size={design.Grid1} />
        <Grid item size={design.Grid4} sx={design.AlignText}>
          <CustomText variant="subtitle1" color="#000" sx={design.Text}>
            En Centro Médico MEDAM, tu salud y la de tu familia son lo más
            importante. Nuestro compromiso es ofrecerte atención médica con
            profesionalismo, cercanía y calidad humana. Sabemos que cada
            paciente es único, por eso te acompañamos en cada paso,
            asegurándonos de que recibas la atención que mereces, siempre con
            empatía, calidez y dedicación.
          </CustomText>
        </Grid>
        <Grid item size={design.Grid11} />

        <Grid item size={design.Grid11} />

        <Grid item size={design.Grid6}>
          <Grid
            container
            spacing={2}
            sx={{
              ...design.Card,
              height: {
                xs: "auto", // móviles: altura automática
                sm: "auto", // pantallas pequeñas
                md: "auto", // pantallas medianas
                lg: "440px", // pantallas grandes
                xl: "400px", // pantallas extra grandes
              },

              backgroundColor: selected?.color,
            }}
          >
            <Grid item size={design.Grid6C} alignSelf="center">
              <ImageLoader
                src={selected?.image}
                alt={selected?.title}
                width="100%"
                height={280}
                borderRadius={3}
              />
            </Grid>

            <Grid item size={design.Grid6C} alignSelf="center">
              <CustomText
                variant="subtitle1"
                color="#FFF"
                sx={design.TextTitulo}
              >
                {selected?.title}
              </CustomText>

              <CustomText
                variant="subtitle1"
                color="#FFF"
                sx={design.Description}
              >
                {selected?.descripCard}
                <br />
                {selected?.description}
              </CustomText>

              <CustomButton
                type="submit"
                variant="contained"
                color="success"
                colorTexto="#215DA6"
                backgroundColor="#FFF"
                width="70%"
                height={50}
                grid={12}
                gridXS={12}
                borderRadius={10}
                style={design.Button}
                onClick={() => {
                  navigate(
                    `/services?name=${encodeURIComponent(selected.name)}`
                  );
                }}
              >
                Conocer más
                <KeyboardArrowRight />
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={design.Grid1} />
      </Grid>
    </Grid>
  );
};

export default TypesOfService;

const design = {
  backgroundIMG: {
    width: "100%",
    backgroundImage: `url("https://centromedicomedam.com/IMG/centromedicoMEDAM/Colorimetria_del_Centro_Medico_Medam.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    marginBottom: {
      xs: -2,
      sm: -5,
      md: -5,
      lg: -11,
      xl: -15,
    },
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 20,
      sm: 36,
      md: 26,
      lg: 40,
      xl: 45,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "3%",
    textAlign: "center",
  },
  Direction: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 5,
    mt: -3,
  },
  AlignButtons: {
    mt: 2,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ButtonBase: {
    padding: "8px 18px",
    borderRadius: "10px",
    fontWeight: 600,
    transition: "0.3s",
    fontSize: {
      xs: 13,
      sm: 14,
      md: 15,
    },
  },
  AlignText: {
    alignSelf: "center",
    paddingRight: { xs: 0, md: 5 },
    textAlign: { xs: "center", md: "left" },
  },
  Text: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 17,
    textAlign: "left",
    lineHeight: "normal",
  },
  Card: {
    borderRadius: 6,
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: { xs: 2, md: 3 },
    paddingRight: { xs: 2, md: 2 },
  },
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 22,
      sm: 26,
      md: 30,
    },
    fontWeight: 700,
    textAlign: "left",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
    marginRight: 2,
  },
  Button: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    marginTop: "5%",
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
  Grid4: { xs: 10, md: 4, xl: 4, lg: 4 },
  Grid6: { xs: 10, md: 6, xl: 6, lg: 6 },
  Grid6C: { xs: 12, md: 12, xl: 6, lg: 6 },
};

const fulter = [
  {
    name: "Torre medica",
    color: "#2349D0",
    title: "Torre Médica",
    descripCard:
      "En nuestra Torre Médica, combinamos tecnología de vanguardia con un equipo de especialistas comprometidos con tu bienestar.",
    description:
      "Aquí recibirás una atención personalizada y profesional, diseñada para atender tus necesidades de salud con excelencia y cercanía.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Torre_Medica_del_centro-medico_MEDAM.jpg",
  },
  {
    name: "Hospitalización",
    color: "#9027E2",
    title: "Hospitalización",
    descripCard:
      "En nuestra área de hospitalización, cuidamos de ti con la misma dedicación con la que lo haríamos por alguien de nuestra familia.",
    description:
      "Contamos con un entorno seguro, tranquilo y confortable, donde nuestro equipo médico y de enfermería trabaja con empatía, profesionalismo y atención personalizada para acompañarte en cada etapa de tu recuperación.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Hospitalizacion_detalles_del_centro-medico_MEDAM.png",
  },
  {
    name: "Urgencias",
    color: "#D00416",
    title: "Urgencias",
    descripCard:
      "En nuestra área de Urgencias, estamos disponibles las 24 horas del día con un equipo médico preparado para atenderte en los momentos más críticos.",
    description:
      "Contamos con personal capacitado y equipamiento adecuado para resolver la mayoría de las situaciones urgentes de forma rápida, segura y con trato humano. Porque cuando se trata de tu salud, cada minuto cuenta.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_detalles__del_centro-medico_MEDAM.jpg",
  },
  {
    name: "Laboratorio Clínico",
    color: "#076C08",
    title: "Laboratorio Clínico",
    descripCard:
      "Nuestro laboratorio clínico es el punto de partida para un diagnóstico confiable. Con tecnología de punta y personal capacitado, garantizamos resultados precisos para que cada paso de tu tratamiento esté respaldado por el profesionalismo que mereces.",
    description:
      "Es por eso que, para cumplir con ese objetivo, nos aliamos con Laboratorio Clínico Durán, uno de los laboratorios más prestigiosos, reconocido por su excelencia y compromiso con la salud.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Laboratorio_Clinico_del_centro-medico_MEDAM.jpg",
  },
];
